export const ACCOUNTING_MODULES = [
  {
    id: 'user-access',
    title: 'User & Access Management',
    icon: '👤',
    path: '/accounting/user-access',
    color: '#6366f1',
    roles: ['admin'],
    features: [
      'Login/Logout, Password reset, MFA (2FA)',
      'Role-Based Access Control (RBAC)',
      'Create/Update/Delete users',
      'User activity logging & login history',
      'Password policies & account lockout'
    ],
    subPages: [
      { label: 'Users & Profiles', path: '/accounting/user-access/users' },
      { label: 'Roles & Permissions', path: '/accounting/user-access/roles' },
      { label: 'Audit Trail', path: '/accounting/user-access/audit' },
      { label: 'Login History', path: '/accounting/user-access/login-history' },
      { label: 'Security Policies', path: '/accounting/user-access/security' }
    ]
  },
  {
    id: 'general-ledger',
    title: 'General Ledger',
    icon: '📒',
    path: '/accounting/general-ledger',
    color: '#0891b2',
    roles: ['admin'],
    features: [
      'Chart of Accounts with hierarchy',
      'Manual, recurring & reversing journal entries',
      'Accounting periods & fiscal year',
      'Multi-currency & exchange rates',
      'Cost centers & department allocation'
    ],
    subPages: [
      { label: 'Chart of Accounts', path: '/accounting/general-ledger/chart-of-accounts' },
      { label: 'Journal Entries', path: '/accounting/general-ledger/journal-entries' },
      { label: 'Accounting Periods', path: '/accounting/general-ledger/periods' },
      { label: 'Multi-Currency', path: '/accounting/general-ledger/currency' },
      { label: 'Cost Centers', path: '/accounting/general-ledger/cost-centers' }
    ]
  },
  {
    id: 'accounts-receivable',
    title: 'Accounts Receivable',
    icon: '💰',
    path: '/accounting/accounts-receivable',
    color: '#16a34a',
    roles: ['admin', 'staff'],
    features: [
      'Customer profiles & credit limits',
      'Invoicing & e-invoicing',
      'Payment collection & partial payments',
      'Credit notes & adjustments',
      'Aging reports & recurring billing'
    ],
    subPages: [
      { label: 'AR Dashboard', path: '/accounting/accounts-receivable' },
      { label: 'Customers', path: '/customers' },
      { label: 'Invoices', path: '/invoices' },
      { label: 'Payment Collection', path: '/credit/payments' },
      { label: 'Aging Reports', path: '/accounting/accounts-receivable/aging' }
    ]
  },
  {
    id: 'accounts-payable',
    title: 'Accounts Payable',
    icon: '💵',
    path: '/accounting/accounts-payable',
    color: '#dc2626',
    roles: ['admin'],
    features: [
      'Vendor management & tax info',
      'Purchase orders & bill matching',
      'Bill approval workflow',
      'Batch payments & expense reports',
      'Duplicate invoice prevention'
    ],
    subPages: [
      { label: 'AP Dashboard', path: '/accounting/accounts-payable' },
      { label: 'Vendors', path: '/accounting/accounts-payable/vendors' },
      { label: 'Purchase Orders', path: '/accounting/accounts-payable/purchase-orders' },
      { label: 'Bills', path: '/accounting/accounts-payable/bills' },
      { label: 'Vendor Aging', path: '/accounting/accounts-payable/aging' }
    ]
  },
  {
    id: 'bank-cash',
    title: 'Bank & Cash Management',
    icon: '🏦',
    path: '/accounting/bank-cash',
    color: '#7c3aed',
    roles: ['admin'],
    features: [
      'Multiple bank accounts',
      'Deposits, withdrawals & transfers',
      'Auto & manual reconciliation',
      'Cash flow forecasting',
      'Petty cash management'
    ],
    subPages: [
      { label: 'Bank Accounts', path: '/accounting/bank-cash/accounts' },
      { label: 'Transactions', path: '/accounting/bank-cash/transactions' },
      { label: 'Reconciliation', path: '/accounting/bank-cash/reconciliation' },
      { label: 'Cash Flow', path: '/accounting/bank-cash/cash-flow' },
      { label: 'Petty Cash', path: '/accounting/bank-cash/petty-cash' }
    ]
  },
  {
    id: 'inventory',
    title: 'Inventory Management',
    icon: '📦',
    path: '/accounting/inventory',
    color: '#ea580c',
    roles: ['admin'],
    features: [
      'Product catalog & SKU management',
      'Real-time stock levels',
      'FIFO/LIFO/Weighted average valuation',
      'Multiple warehouse support',
      'Stock adjustments & cycle counting'
    ],
    subPages: [
      { label: 'Products', path: '/products' },
      { label: 'GRN', path: '/grn' },
      { label: 'Stock Valuation', path: '/accounting/inventory/valuation' },
      { label: 'Warehouses', path: '/accounting/inventory/warehouses' },
      { label: 'Adjustments', path: '/accounting/inventory/adjustments' }
    ]
  },
  {
    id: 'fixed-assets',
    title: 'Fixed Assets',
    icon: '🏢',
    path: '/accounting/fixed-assets',
    color: '#0d9488',
    roles: ['admin'],
    features: [
      'Asset register & serial tracking',
      'Straight-line & declining balance depreciation',
      'Asset disposal & gain/loss',
      'Maintenance scheduling',
      'Warranty tracking'
    ],
    subPages: [
      { label: 'Asset Register', path: '/accounting/fixed-assets/register' },
      { label: 'Depreciation', path: '/accounting/fixed-assets/depreciation' },
      { label: 'Disposal', path: '/accounting/fixed-assets/disposal' },
      { label: 'Maintenance', path: '/accounting/fixed-assets/maintenance' }
    ]
  },
  {
    id: 'tax',
    title: 'Tax Management',
    icon: '🧾',
    path: '/accounting/tax',
    color: '#be185d',
    roles: ['admin'],
    features: [
      'GST/VAT/Sales tax rates',
      'Auto tax calculation',
      'Tax liability reports',
      'Multi-jurisdiction support',
      'Tax exemptions'
    ],
    subPages: [
      { label: 'Tax Rates', path: '/accounting/tax/rates' },
      { label: 'Tax Codes', path: '/accounting/tax/codes' },
      { label: 'Tax Reports', path: '/accounting/tax/reports' },
      { label: 'Jurisdictions', path: '/accounting/tax/jurisdictions' }
    ]
  },
  {
    id: 'reporting',
    title: 'Reporting & Analytics',
    icon: '📊',
    path: '/accounting/reporting',
    color: '#2563eb',
    roles: ['admin'],
    features: [
      'Balance Sheet, P&L, Trial Balance',
      'AR/AP aging & statements',
      'KPI dashboards & trend analysis',
      'Custom report builder',
      'Export PDF/Excel/CSV'
    ],
    subPages: [
      { label: 'Financial Reports', path: '/accounting/reporting/financial' },
      { label: 'Trial Balance', path: '/accounting/reporting/trial-balance' },
      { label: 'Profit & Loss', path: '/accounting/reporting/profit-loss' },
      { label: 'Balance Sheet', path: '/accounting/reporting/balance-sheet' },
      { label: 'Custom Reports', path: '/reports' }
    ]
  },
  {
    id: 'budgeting',
    title: 'Budgeting & Forecasting',
    icon: '💼',
    path: '/accounting/budgeting',
    color: '#4f46e5',
    roles: ['admin'],
    features: [
      'Annual & department budgets',
      'Actual vs Budget variance',
      'Sales & expense forecasting',
      'What-if scenario planning',
      'Cash flow forecasting'
    ],
    subPages: [
      { label: 'Budgets', path: '/accounting/budgeting/budgets' },
      { label: 'Variance Analysis', path: '/accounting/budgeting/variance' },
      { label: 'Forecasting', path: '/accounting/budgeting/forecasting' },
      { label: 'Scenarios', path: '/accounting/budgeting/scenarios' }
    ]
  },
  {
    id: 'communications',
    title: 'Communications',
    icon: '📨',
    path: '/accounting/communications',
    color: '#0284c7',
    roles: ['admin'],
    features: [
      'Email notifications',
      'In-app alerts & action center',
      'SMS critical alerts',
      'Invoice & statement PDF generation',
      'Approval request notifications'
    ],
    subPages: [
      { label: 'Notifications', path: '/accounting/communications/notifications' },
      { label: 'Email Templates', path: '/accounting/communications/email' },
      { label: 'Document Generation', path: '/accounting/communications/documents' }
    ]
  },
  {
    id: 'integrations',
    title: 'Integrations',
    icon: '🔗',
    path: '/accounting/integrations',
    color: '#059669',
    roles: ['admin'],
    features: [
      'Bank feeds (Plaid/Yodlee)',
      'Payment gateways (Stripe/PayPal)',
      'CRM sync (Salesforce/HubSpot)',
      'E-commerce (Shopify/WooCommerce)',
      'RESTful API & webhooks'
    ],
    subPages: [
      { label: 'Bank Integration', path: '/accounting/integrations/bank' },
      { label: 'Payment Gateways', path: '/accounting/integrations/payments' },
      { label: 'CRM', path: '/accounting/integrations/crm' },
      { label: 'API & Webhooks', path: '/accounting/integrations/api' }
    ]
  },
  {
    id: 'system-admin',
    title: 'System Administration',
    icon: '⚙️',
    path: '/accounting/system-admin',
    color: '#64748b',
    roles: ['admin'],
    features: [
      'Company profile & fiscal year',
      'Email/SMTP configuration',
      'Automated backups',
      'Data archiving & purge policies',
      'System & error logs'
    ],
    subPages: [
      { label: 'Company Settings', path: '/accounting/system-admin/company' },
      { label: 'Configuration', path: '/settings' },
      { label: 'Backup & Export', path: '/accounting/system-admin/backup' },
      { label: 'System Logs', path: '/accounting/system-admin/logs' }
    ]
  },
  {
    id: 'security',
    title: 'Security & Compliance',
    icon: '🔐',
    path: '/accounting/security',
    color: '#b45309',
    roles: ['admin'],
    features: [
      'Data encryption at rest & in transit',
      'GDPR & SOX compliance tools',
      'Data retention policies',
      'Security audit logs',
      'Disaster recovery'
    ],
    subPages: [
      { label: 'Compliance', path: '/accounting/security/compliance' },
      { label: 'Data Privacy', path: '/accounting/security/privacy' },
      { label: 'Backup Recovery', path: '/accounting/security/recovery' }
    ]
  },
  {
    id: 'mobile',
    title: 'Mobile & Accessibility',
    icon: '📱',
    path: '/accounting/mobile',
    color: '#9333ea',
    roles: ['admin', 'staff'],
    features: [
      'Responsive design (desktop/tablet/mobile)',
      'Progressive Web App support',
      'Role-based views',
      'WCAG accessibility compliance',
      'Screen reader support'
    ],
    subPages: [
      { label: 'Mobile Views', path: '/accounting/mobile/views' },
      { label: 'Accessibility', path: '/accounting/mobile/accessibility' }
    ]
  },
  {
    id: 'advanced',
    title: 'Advanced Features',
    icon: '🚀',
    path: '/accounting/advanced',
    color: '#e11d48',
    roles: ['admin'],
    features: [
      'AI auto-categorization',
      'Smart duplicate detection',
      'Auto-reconciliation',
      'OCR receipt scanning',
      'RPA automation'
    ],
    subPages: [
      { label: 'AI/ML Tools', path: '/accounting/advanced/ai' },
      { label: 'Automation', path: '/accounting/advanced/automation' },
      { label: 'OCR Scanning', path: '/accounting/advanced/ocr' }
    ]
  }
];

export const getModuleByPath = (path) => {
  return ACCOUNTING_MODULES.find(m => path === m.path || path.startsWith(m.path + '/'));
};

export const getModuleById = (id) => ACCOUNTING_MODULES.find(m => m.id === id);
